import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthLoginService } from '../../services/auth-login/auth-login.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  return inject(AuthLoginService).canActivate(route, state);
};
